/**
 * Country Codes Data
 * Contains country codes with flag emojis and country names
 * Used for phone number input dropdowns
 */

export const countryCodes = [
  { code: '+1', flag: '🇺🇸', name: 'United States', iso: 'US' },
  { code: '+44', flag: '🇬🇧', name: 'United Kingdom', iso: 'GB' },
  { code: '+91', flag: '🇮🇳', name: 'India', iso: 'IN' },
  { code: '+971', flag: '🇦🇪', name: 'United Arab Emirates', iso: 'AE' },
  { code: '+966', flag: '🇸🇦', name: 'Saudi Arabia', iso: 'SA' },
  { code: '+974', flag: '🇶🇦', name: 'Qatar', iso: 'QA' },
  { code: '+965', flag: '🇰🇼', name: 'Kuwait', iso: 'KW' },
  { code: '+973', flag: '🇧🇭', name: 'Bahrain', iso: 'BH' },
  { code: '+968', flag: '🇴🇲', name: 'Oman', iso: 'OM' },
  { code: '+961', flag: '🇱🇧', name: 'Lebanon', iso: 'LB' },
  { code: '+962', flag: '🇯🇴', name: 'Jordan', iso: 'JO' },
  { code: '+20', flag: '🇪🇬', name: 'Egypt', iso: 'EG' },
  { code: '+27', flag: '🇿🇦', name: 'South Africa', iso: 'ZA' },
  { code: '+61', flag: '🇦🇺', name: 'Australia', iso: 'AU' },
  { code: '+64', flag: '🇳🇿', name: 'New Zealand', iso: 'NZ' },
  { code: '+86', flag: '🇨🇳', name: 'China', iso: 'CN' },
  { code: '+81', flag: '🇯🇵', name: 'Japan', iso: 'JP' },
  { code: '+82', flag: '🇰🇷', name: 'South Korea', iso: 'KR' },
  { code: '+65', flag: '🇸🇬', name: 'Singapore', iso: 'SG' },
  { code: '+60', flag: '🇲🇾', name: 'Malaysia', iso: 'MY' },
  { code: '+66', flag: '🇹🇭', name: 'Thailand', iso: 'TH' },
  { code: '+62', flag: '🇮🇩', name: 'Indonesia', iso: 'ID' },
  { code: '+63', flag: '🇵🇭', name: 'Philippines', iso: 'PH' },
  { code: '+84', flag: '🇻🇳', name: 'Vietnam', iso: 'VN' },
  { code: '+92', flag: '🇵🇰', name: 'Pakistan', iso: 'PK' },
  { code: '+880', flag: '🇧🇩', name: 'Bangladesh', iso: 'BD' },
  { code: '+94', flag: '🇱🇰', name: 'Sri Lanka', iso: 'LK' },
  { code: '+95', flag: '🇲🇲', name: 'Myanmar', iso: 'MM' },
  { code: '+977', flag: '🇳🇵', name: 'Nepal', iso: 'NP' },
  { code: '+33', flag: '🇫🇷', name: 'France', iso: 'FR' },
  { code: '+49', flag: '🇩🇪', name: 'Germany', iso: 'DE' },
  { code: '+39', flag: '🇮🇹', name: 'Italy', iso: 'IT' },
  { code: '+34', flag: '🇪🇸', name: 'Spain', iso: 'ES' },
  { code: '+31', flag: '🇳🇱', name: 'Netherlands', iso: 'NL' },
  { code: '+32', flag: '🇧🇪', name: 'Belgium', iso: 'BE' },
  { code: '+41', flag: '🇨🇭', name: 'Switzerland', iso: 'CH' },
  { code: '+43', flag: '🇦🇹', name: 'Austria', iso: 'AT' },
  { code: '+46', flag: '🇸🇪', name: 'Sweden', iso: 'SE' },
  { code: '+47', flag: '🇳🇴', name: 'Norway', iso: 'NO' },
  { code: '+45', flag: '🇩🇰', name: 'Denmark', iso: 'DK' },
  { code: '+358', flag: '🇫🇮', name: 'Finland', iso: 'FI' },
  { code: '+7', flag: '🇷🇺', name: 'Russia', iso: 'RU' },
  { code: '+90', flag: '🇹🇷', name: 'Turkey', iso: 'TR' },
  { code: '+30', flag: '🇬🇷', name: 'Greece', iso: 'GR' },
  { code: '+48', flag: '🇵🇱', name: 'Poland', iso: 'PL' },
  { code: '+420', flag: '🇨🇿', name: 'Czech Republic', iso: 'CZ' },
  { code: '+36', flag: '🇭🇺', name: 'Hungary', iso: 'HU' },
  { code: '+40', flag: '🇷🇴', name: 'Romania', iso: 'RO' },
  { code: '+353', flag: '🇮🇪', name: 'Ireland', iso: 'IE' },
  { code: '+1', flag: '🇨🇦', name: 'Canada', iso: 'CA' },
  { code: '+52', flag: '🇲🇽', name: 'Mexico', iso: 'MX' },
  { code: '+55', flag: '🇧🇷', name: 'Brazil', iso: 'BR' },
  { code: '+54', flag: '🇦🇷', name: 'Argentina', iso: 'AR' },
  { code: '+56', flag: '🇨🇱', name: 'Chile', iso: 'CL' },
  { code: '+57', flag: '🇨🇴', name: 'Colombia', iso: 'CO' },
  { code: '+51', flag: '🇵🇪', name: 'Peru', iso: 'PE' },
  { code: '+234', flag: '🇳🇬', name: 'Nigeria', iso: 'NG' },
  { code: '+254', flag: '🇰🇪', name: 'Kenya', iso: 'KE' },
  { code: '+233', flag: '🇬🇭', name: 'Ghana', iso: 'GH' },
  { code: '+212', flag: '🇲🇦', name: 'Morocco', iso: 'MA' },
  { code: '+213', flag: '🇩🇿', name: 'Algeria', iso: 'DZ' },
  { code: '+216', flag: '🇹🇳', name: 'Tunisia', iso: 'TN' },
  { code: '+218', flag: '🇱🇾', name: 'Libya', iso: 'LY' },
  { code: '+249', flag: '🇸🇩', name: 'Sudan', iso: 'SD' },
  { code: '+251', flag: '🇪🇹', name: 'Ethiopia', iso: 'ET' },
  { code: '+255', flag: '🇹🇿', name: 'Tanzania', iso: 'TZ' },
  { code: '+256', flag: '🇺🇬', name: 'Uganda', iso: 'UG' },
  { code: '+250', flag: '🇷🇼', name: 'Rwanda', iso: 'RW' },
  { code: '+260', flag: '🇿🇲', name: 'Zambia', iso: 'ZM' },
  { code: '+263', flag: '🇿🇼', name: 'Zimbabwe', iso: 'ZW' },
  { code: '+264', flag: '🇳🇦', name: 'Namibia', iso: 'NA' },
  { code: '+267', flag: '🇧🇼', name: 'Botswana', iso: 'BW' },
  { code: '+268', flag: '🇸🇿', name: 'Eswatini', iso: 'SZ' },
  { code: '+269', flag: '🇰🇲', name: 'Comoros', iso: 'KM' },
  { code: '+230', flag: '🇲🇺', name: 'Mauritius', iso: 'MU' },
  { code: '+248', flag: '🇸🇨', name: 'Seychelles', iso: 'SC' },
  { code: '+252', flag: '🇸🇴', name: 'Somalia', iso: 'SO' },
  { code: '+253', flag: '🇩🇯', name: 'Djibouti', iso: 'DJ' },
  { code: '+257', flag: '🇧🇮', name: 'Burundi', iso: 'BI' },
  { code: '+258', flag: '🇲🇿', name: 'Mozambique', iso: 'MZ' },
  { code: '+261', flag: '🇲🇬', name: 'Madagascar', iso: 'MG' },
  { code: '+262', flag: '🇷🇪', name: 'Réunion', iso: 'RE' },
  { code: '+265', flag: '🇲🇼', name: 'Malawi', iso: 'MW' },
  { code: '+266', flag: '🇱🇸', name: 'Lesotho', iso: 'LS' },
  { code: '+290', flag: '🇸🇭', name: 'Saint Helena', iso: 'SH' },
  { code: '+291', flag: '🇪🇷', name: 'Eritrea', iso: 'ER' },
  { code: '+297', flag: '🇦🇼', name: 'Aruba', iso: 'AW' },
  { code: '+298', flag: '🇫🇴', name: 'Faroe Islands', iso: 'FO' },
  { code: '+299', flag: '🇬🇱', name: 'Greenland', iso: 'GL' },
  { code: '+350', flag: '🇬🇮', name: 'Gibraltar', iso: 'GI' },
  { code: '+352', flag: '🇱🇺', name: 'Luxembourg', iso: 'LU' },
  { code: '+354', flag: '🇮🇸', name: 'Iceland', iso: 'IS' },
  { code: '+355', flag: '🇦🇱', name: 'Albania', iso: 'AL' },
  { code: '+356', flag: '🇲🇹', name: 'Malta', iso: 'MT' },
  { code: '+357', flag: '🇨🇾', name: 'Cyprus', iso: 'CY' },
  { code: '+359', flag: '🇧🇬', name: 'Bulgaria', iso: 'BG' },
  { code: '+370', flag: '🇱🇹', name: 'Lithuania', iso: 'LT' },
  { code: '+371', flag: '🇱🇻', name: 'Latvia', iso: 'LV' },
  { code: '+372', flag: '🇪🇪', name: 'Estonia', iso: 'EE' },
  { code: '+373', flag: '🇲🇩', name: 'Moldova', iso: 'MD' },
  { code: '+374', flag: '🇦🇲', name: 'Armenia', iso: 'AM' },
  { code: '+375', flag: '🇧🇾', name: 'Belarus', iso: 'BY' },
  { code: '+376', flag: '🇦🇩', name: 'Andorra', iso: 'AD' },
  { code: '+377', flag: '🇲🇨', name: 'Monaco', iso: 'MC' },
  { code: '+378', flag: '🇸🇲', name: 'San Marino', iso: 'SM' },
  { code: '+380', flag: '🇺🇦', name: 'Ukraine', iso: 'UA' },
  { code: '+381', flag: '🇷🇸', name: 'Serbia', iso: 'RS' },
  { code: '+382', flag: '🇲🇪', name: 'Montenegro', iso: 'ME' },
  { code: '+383', flag: '🇽🇰', name: 'Kosovo', iso: 'XK' },
  { code: '+385', flag: '🇭🇷', name: 'Croatia', iso: 'HR' },
  { code: '+386', flag: '🇸🇮', name: 'Slovenia', iso: 'SI' },
  { code: '+387', flag: '🇧🇦', name: 'Bosnia and Herzegovina', iso: 'BA' },
  { code: '+389', flag: '🇲🇰', name: 'North Macedonia', iso: 'MK' },
  { code: '+421', flag: '🇸🇰', name: 'Slovakia', iso: 'SK' },
  { code: '+423', flag: '🇱🇮', name: 'Liechtenstein', iso: 'LI' },
  { code: '+500', flag: '🇫🇰', name: 'Falkland Islands', iso: 'FK' },
  { code: '+501', flag: '🇧🇿', name: 'Belize', iso: 'BZ' },
  { code: '+502', flag: '🇬🇹', name: 'Guatemala', iso: 'GT' },
  { code: '+503', flag: '🇸🇻', name: 'El Salvador', iso: 'SV' },
  { code: '+504', flag: '🇭🇳', name: 'Honduras', iso: 'HN' },
  { code: '+505', flag: '🇳🇮', name: 'Nicaragua', iso: 'NI' },
  { code: '+506', flag: '🇨🇷', name: 'Costa Rica', iso: 'CR' },
  { code: '+507', flag: '🇵🇦', name: 'Panama', iso: 'PA' },
  { code: '+508', flag: '🇵🇲', name: 'Saint Pierre and Miquelon', iso: 'PM' },
  { code: '+509', flag: '🇭🇹', name: 'Haiti', iso: 'HT' },
  { code: '+590', flag: '🇬🇵', name: 'Guadeloupe', iso: 'GP' },
  { code: '+591', flag: '🇧🇴', name: 'Bolivia', iso: 'BO' },
  { code: '+592', flag: '🇬🇾', name: 'Guyana', iso: 'GY' },
  { code: '+593', flag: '🇪🇨', name: 'Ecuador', iso: 'EC' },
  { code: '+594', flag: '🇬🇫', name: 'French Guiana', iso: 'GF' },
  { code: '+595', flag: '🇵🇾', name: 'Paraguay', iso: 'PY' },
  { code: '+596', flag: '🇲🇶', name: 'Martinique', iso: 'MQ' },
  { code: '+597', flag: '🇸🇷', name: 'Suriname', iso: 'SR' },
  { code: '+598', flag: '🇺🇾', name: 'Uruguay', iso: 'UY' },
  { code: '+599', flag: '🇧🇶', name: 'Caribbean Netherlands', iso: 'BQ' },
  { code: '+670', flag: '🇹🇱', name: 'Timor-Leste', iso: 'TL' },
  { code: '+672', flag: '🇦🇶', name: 'Antarctica', iso: 'AQ' },
  { code: '+673', flag: '🇧🇳', name: 'Brunei', iso: 'BN' },
  { code: '+674', flag: '🇳🇷', name: 'Nauru', iso: 'NR' },
  { code: '+675', flag: '🇵🇬', name: 'Papua New Guinea', iso: 'PG' },
  { code: '+676', flag: '🇹🇴', name: 'Tonga', iso: 'TO' },
  { code: '+677', flag: '🇸🇧', name: 'Solomon Islands', iso: 'SB' },
  { code: '+678', flag: '🇻🇺', name: 'Vanuatu', iso: 'VU' },
  { code: '+679', flag: '🇫🇯', name: 'Fiji', iso: 'FJ' },
  { code: '+680', flag: '🇵🇼', name: 'Palau', iso: 'PW' },
  { code: '+681', flag: '🇼🇫', name: 'Wallis and Futuna', iso: 'WF' },
  { code: '+682', flag: '🇨🇰', name: 'Cook Islands', iso: 'CK' },
  { code: '+683', flag: '🇳🇺', name: 'Niue', iso: 'NU' },
  { code: '+684', flag: '🇦🇸', name: 'American Samoa', iso: 'AS' },
  { code: '+685', flag: '🇼🇸', name: 'Samoa', iso: 'WS' },
  { code: '+686', flag: '🇰🇮', name: 'Kiribati', iso: 'KI' },
  { code: '+687', flag: '🇳🇨', name: 'New Caledonia', iso: 'NC' },
  { code: '+688', flag: '🇹🇻', name: 'Tuvalu', iso: 'TV' },
  { code: '+689', flag: '🇵🇫', name: 'French Polynesia', iso: 'PF' },
  { code: '+690', flag: '🇹🇰', name: 'Tokelau', iso: 'TK' },
  { code: '+691', flag: '🇫🇲', name: 'Micronesia', iso: 'FM' },
  { code: '+692', flag: '🇲🇭', name: 'Marshall Islands', iso: 'MH' },
  { code: '+850', flag: '🇰🇵', name: 'North Korea', iso: 'KP' },
  { code: '+852', flag: '🇭🇰', name: 'Hong Kong', iso: 'HK' },
  { code: '+853', flag: '🇲🇴', name: 'Macau', iso: 'MO' },
  { code: '+855', flag: '🇰🇭', name: 'Cambodia', iso: 'KH' },
  { code: '+856', flag: '🇱🇦', name: 'Laos', iso: 'LA' },
  { code: '+886', flag: '🇹🇼', name: 'Taiwan', iso: 'TW' },
  { code: '+960', flag: '🇲🇻', name: 'Maldives', iso: 'MV' },
  { code: '+963', flag: '🇸🇾', name: 'Syria', iso: 'SY' },
  { code: '+964', flag: '🇮🇶', name: 'Iraq', iso: 'IQ' },
  { code: '+967', flag: '🇾🇪', name: 'Yemen', iso: 'YE' },
  { code: '+970', flag: '🇵🇸', name: 'Palestine', iso: 'PS' },
  { code: '+972', flag: '🇮🇱', name: 'Israel', iso: 'IL' },
  { code: '+975', flag: '🇧🇹', name: 'Bhutan', iso: 'BT' },
  { code: '+976', flag: '🇲🇳', name: 'Mongolia', iso: 'MN' },
  { code: '+992', flag: '🇹🇯', name: 'Tajikistan', iso: 'TJ' },
  { code: '+993', flag: '🇹🇲', name: 'Turkmenistan', iso: 'TM' },
  { code: '+994', flag: '🇦🇿', name: 'Azerbaijan', iso: 'AZ' },
  { code: '+995', flag: '🇬🇪', name: 'Georgia', iso: 'GE' },
  { code: '+996', flag: '🇰🇬', name: 'Kyrgyzstan', iso: 'KG' },
  { code: '+998', flag: '🇺🇿', name: 'Uzbekistan', iso: 'UZ' },
];

// Get country code by code value
export const getCountryByCode = (code) => {
  return countryCodes.find(country => country.code === code) || countryCodes[2]; // Default to India
};

// Get default country (India)
export const getDefaultCountry = () => {
  return countryCodes.find(country => country.code === '+91') || countryCodes[2];
};

// Get country by name (case-insensitive, partial match)
export const getCountryByName = (name) => {
  // Guard: name may arrive as a non-string (array/object/number) from the API — coerce safely
  if (name == null) return null;
  const searchName = String(Array.isArray(name) ? name[0] : name).toLowerCase().trim();
  if (!searchName) return null;
  // Try exact match first
  let found = countryCodes.find(country => country.name.toLowerCase() === searchName);
  // If not found, try partial match
  if (!found) {
    found = countryCodes.find(country => country.name.toLowerCase().includes(searchName));
  }
  return found || null;
};

// Sort countries alphabetically by name
export const getSortedCountries = () => {
  return [...countryCodes].sort((a, b) => a.name.localeCompare(b.name));
};

